var _jsxFileName = "/codebuild/output/src2892718592/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/PhoneInput/InfoBottomSheetModal.tsx";
import React, { useCallback, useEffect, useRef } from 'react';
import { BottomSheet, IconClose, Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const InfoBottomSheetModal = ({
  isOpen,
  setIsOpen
}) => {
  const ref = useRef(null);
  const handleClose = useCallback(() => {
    var _ref$current;
    setIsOpen(false);
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.dismiss();
  }, [setIsOpen]);
  useEffect(() => {
    if (isOpen) {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.present();
    } else {
      var _ref$current3;
      (_ref$current3 = ref.current) === null || _ref$current3 === void 0 || _ref$current3.dismiss();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheet, {
    ref: ref,
    enableDynamicSizing: true,
    topNavigationProps: {
      title: i18n.t('CreateAccountAccountInfo.modals.addMobileNumber.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(IconClose, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 22
          }
        }),
        onPress: handleClose,
        label: i18n.t('Global.microcopy.common.cancel')
      }
    },
    onBackdropClick: handleClose,
    onDismiss: handleClose,
    testID: "MobileNumberInfoBottomSheetModal",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "column",
    gap: "$4",
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "CreateAccountAccountInfo.modals.addMobileNumber.body",
    nativeID: "CreateAccountAccountInfo.modals.addMobileNumber.body",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.helpText.verifyAccountModal')))));
};
export default InfoBottomSheetModal;